import React from 'react';
import useRUMView from 'common-datadog/useRUMView';

import Screen from '../Screen';
import Form from '../Form';
import InputFirstName from '../InputNameFirst';
import InputLastName from '../InputNameLast';
import InputsAddressStreet from '../InputAddressStreet';
import InputsAddressSecondary from '../InputAddressSecondary';
import InputsAddressCity from '../InputAddressCity';
import InputsAddressState from '../InputAddressState';
import InputsAddressZipCode from '../InputAddressZipCode';
import InputPhone from '../InputPhone';
import PhoneExists from '../PhoneExists';
import ButtonPrimary from '../ButtonPrimary';
import Disclaimers from '../Disclaimers';

import useForm from './useForm';
import useMe from '../../resources/me';
import usePrefill from '../../resources/prefill';

import {
  PHONE_PRESENT_ON_EXISTING_ACCOUNT,
  PHONE_DISCLAIMER,
  TEXT_DISCLAIMER,
  WEBBANK_DISCLAIMER,
} from '../../constants';

const Reapply = () => {
  useRUMView('reapply');
  const { data: prefill } = usePrefill();
  const { data: me } = useMe();

  const {
    form,
    isSubmitting,
    handleSubmit,
    error,
  } = useForm();

  if (error === PHONE_PRESENT_ON_EXISTING_ACCOUNT) {
    return <PhoneExists onBack={() => form.clearErrors()} />;
  }

  return (
    <Screen
      header={`Welcome back, ${me.firstName}.`}
      subheader="Let's ensure your information is correct before continuing."
    >
      <Form
        noValidate
        form={form}
        onSubmit={handleSubmit}
      >
        <InputFirstName prefill={prefill?.firstName} />
        <InputLastName prefill={prefill?.lastName} />
        <InputsAddressStreet prefill={prefill?.street} />
        <InputsAddressSecondary prefill={prefill?.secondary} />
        <InputsAddressCity prefill={prefill?.city} />
        <InputsAddressState prefill={prefill?.state} />
        <InputsAddressZipCode prefill={prefill?.zipCode} />
        <InputPhone prefill={prefill?.phone} />
        <ButtonPrimary isLoading={isSubmitting}>
          Continue
        </ButtonPrimary>
      </Form>
      <Disclaimers>
        {WEBBANK_DISCLAIMER}
        {PHONE_DISCLAIMER}
        {TEXT_DISCLAIMER}
      </Disclaimers>
    </Screen>
  );
};

export default Reapply;
